import {USER_POSITION_CHANGED} from '../constants/maps';

export const userPositionChanged = (position) => {
	return {
		type: USER_POSITION_CHANGED,
		payload: {
			position
		}
	};
};